import TreeCommonNode from './TreeCommonNode/TreeCommonNode'


const TreeNode = ({ node, style, tree, onSelect = () => {},  ...props }) => {
  const isFirstNode = node.parent?.level === -1 // node.id === tree.firstNode.id
  const isContainerNode = !!node.data.data.nb_children //!node?.nextSibling

  return (
    <TreeCommonNode
      node={node}
      style={style}
      tree={tree}
      displayToggleIcon={isContainerNode}
      displayLines={!isFirstNode}
      onSelect={onSelect}
      {...props}
    />
  )
}

export default TreeNode
